import { z } from 'zod'
import {
  CompanyType,
  CompanyUsersRelation,
  CompanyUsersStatus
} from '../types/companies.types'
import { roleSchema } from './roles.schema'
import { userSchema } from './users.schemas'

export const companySchema = z.object({
  id: z.uuid(),
  name: z.string(),
  tin: z.string(),
  type: z.enum(CompanyType),
  logoUri: z.string().optional().nullable(),
  address: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  zipcode: z.string().optional(),
  webUrl: z.string().optional(),
  did: z.string(),
  didPrivateKeyHex: z.string(),
  createdAt: z.iso.datetime().optional(),
  updatedAt: z.iso.datetime().optional(),
  didStatus: z.string()
})

export const companyUserSchema = z.object({
  companyId: z.uuid(),
  roleId: z.uuid().optional(),
  userId: z.uuid(),
  status: z.enum(CompanyUsersStatus),
  relation: z.enum(CompanyUsersRelation).optional(),
  jobTitle: z.string().optional(),
  createdAt: z.iso.datetime().optional(),
  updatedAt: z.iso.datetime().optional()
})

export const companyUserWithCompanySchema = companyUserSchema.extend({
  company: companySchema
})

export const companyUserWithUserSchema = companyUserSchema.extend({
  user: userSchema
})

export const companyUserWithCompanyAndRoleSchema = companyUserSchema.extend({
  company: companySchema,
  role: roleSchema
})

export const companyUserWithUserAndRoleSchema = companyUserSchema.extend({
  user: userSchema,
  role: roleSchema
})
export const companyFullAccessSchema = z.object({
  id: z.uuid(),
  name: z.string()
})
export const companiesWithFullAccessSchema = z.array(companyFullAccessSchema)

export const companyUserWithRoleAndPermissionsSchema = companyUserSchema.extend(
  {
    user: userSchema,
    role: roleSchema,
    permissions: z.array(z.string())
  }
)
